import './mutators/forgottenAttachmentsPluginStateMutators';

export { ForgottenAttachmentsPlugin } from './plugins/ForgottenAttachmentsPlugin';
